import './platform-slider.scss';
import 'slick-carousel';

export default () => {
	while ( $( '.js-platform-slider > div' ).length == 2 ) {
		$( '.js-platform-slider > div' ).each( function () {
			$( this ).clone().appendTo( '.js-platform-slider' );
		} );
	}
	// Slick Slider
	$( '.js-platform-slider' ).slick( {
		dots: true,
		arrows: true,
		infinite: true,
		speed: 300,
		slidesToShow: 2,
		swipe: true,
		slidesToScroll: 1,
		appendArrows: '.platform-slider__slider-arrows',
		appendDots: '.platform-slider__slider-navs',
		nextArrow:
			'<button class=\'slick-next\'><i class=\'icon-arrow-next\'></i></button>',
		prevArrow:
			'<button class=\'slick-prev\'><i class=\'icon-arrow-prev\'></i></button>',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	} );
};
